import { FC } from 'react';
import styles from './About.module.css';
import {
  MDBCard,
  MDBCardImage,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol
} from 'mdb-react-ui-kit';
import { useTranslation } from 'react-i18next';

interface AboutProps { }

const About: FC<AboutProps> = () => {

  const { t } = useTranslation();
  return (
    <div className={styles.About}>
      <div className='pb-4 border rounded-5 p-4 w-100 contrasting-bg' style={{ minHeight: 'calc(100vh - 389.56px)' }}>
        <div className='d-flex justify-content-center align-items-center'>
          <MDBRow className='row-cols-1 row-cols-md-2'>
            <MDBCol>
              <MDBCard className='h-100' style={{ maxWidth: '22rem' }}>
                <MDBCardImage
                  src='oxana.jpg'
                  alt='Oxana Eide'
                  position='top'
                />
                <MDBCardBody>
                  <MDBCardTitle>Oxana Eide</MDBCardTitle>
                  <MDBCardText>
                    <h6>{t('Senior consultant')}/{t('Manager')}</h6>
                    <br />
                    <p style={{ textAlign: 'left' }}>
                      {t('Oxana_info_1')}
                    </p>
                    <p style={{ textAlign: 'left' }}>
                      {t('Oxana_info_2')}
                    </p>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
            <MDBCol>
              <MDBCard className='h-100' style={{ maxWidth: '22rem' }}>
                <MDBCardImage
                  src='magne.jpg'
                  alt='Magne Tøndel'
                  position='top'
                />
                <MDBCardBody>
                  <MDBCardTitle>Magne Tøndel<br /></MDBCardTitle>
                  <MDBCardText>
                    <h6>{t('Senior consultant')}</h6>
                    <br />
                    <p style={{ textAlign: 'left' }}>
                      {t('Magne_info_1')}
                    </p>
                    <p style={{ textAlign: 'left' }}>
                      {t('Magne_info_2')}
                    </p>
                  </MDBCardText>
                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          </MDBRow>
        </div>
      </div>
    </div>
  );
}

export default About;
